module.exports = __webpack_public_path__ + "static/yellow-fever-e82e1ec70ba90fd09bfbd29657755d0a.png";